import { Image, ImageProps } from '@chakra-ui/react';
import { IMAGE_LAZY } from '@utils/constant';
import { FC, useState } from 'react';

interface IProps extends ImageProps {}
const MyImage: FC<IProps> = ({ ...props }) => {
  const [src, setSrc] = useState(props?.src);

  const handleError = () => {
    setSrc(IMAGE_LAZY);
  };

  return (
    <Image
      {...props}
      src={src || props?.src}
      fallbackSrc={IMAGE_LAZY}
      loading="lazy"
      onError={handleError}
    />
  );
};

export default MyImage;
